module.exports = __webpack_public_path__ + "img/DAT.eef673ef.svg";